/**
@prop --ux-stepper-gap-size: spacing between input and stepper buttons
@prop --ux-stepper-button-bg-color: background-color of the stepper buttons
@prop --ux-stepper-button-focus-bg-color: background-color of the stepper buttons when focussed
@prop --ux-stepper-button-hover-text-color: text color of the stepper buttons when hovered
@prop --ux-stepper-button-shadow: box-shadow of the stepper buttons
 */
.ux-stepper {
  box-sizing: border-box;
  display: block;
  margin: 0;
  max-width: 100%;
  position: relative;

  .ux-input-field-number__buttons {
    margin-left: var(--ux-stepper-gap-size);
  }

  ux-button:not([disabled]) {
    z-index: 1;
  }

  ux-button:hover,
  ux-button:active,
  ux-button:focus {
    z-index: 2;
  }

  &__decrease,
  &__increase {
    --ux-button-shadow: var(--ux-stepper-button-shadow);
    --ux-button-bg-color: var(--ux-stepper-button-bg-color);
    --ux-button-disabled-bg-color: var(--ux-stepper-button-bg-color);
    --ux-button-hover-bg-color: var(--ux-stepper-button-bg-color);
    --ux-button-focus-bg-color: var(--ux-stepper-button-focus-bg-color);
    --ux-button-hover-text-color: var(--ux-stepper-button-hover-text-color);

    padding: 0;

    .ux-button {
      height: 100%;
      min-height: 0;
      padding: 0;
    }
  }

  &__decrease {
    margin-right: -1px;
  }
}
